(function(){
function moveAfter(el,target){if(el&&target)target.insertAdjacentElement('afterend',el);}
function styleBlock(el){if(!el)return;el.style.setProperty('margin','8px 0 10px','important');}
function setupCorporate(){
var root=document.querySelector('.sp-corporate-round');if(!root)return;
var step=root.querySelector('.sp-corp-artwork');if(!step)return;
var choices=step.querySelector('.sp-artwork-choice'),upload=step.querySelector('#corp-art-note'),word=step.querySelector('#corp-wording-wrap');
if(!choices||!upload||!word)return;
function place(){
var checked=choices.querySelector('input[name="corp-artwork"]:checked');if(!checked)return;
var label=checked.closest('label'),v=checked.value;
if(v==='logo'){moveAfter(upload,label);}
else if(v==='text'){moveAfter(word,label);}
else{moveAfter(upload,label);moveAfter(word,upload);}
styleBlock(upload);styleBlock(word);
}
choices.addEventListener('change',function(){setTimeout(place,0);});place();
}
function setupCustom(){
var root=document.querySelector('.sp-cyc-topper');if(!root)return;
var choices=root.querySelector('.sp-artwork-choice'),upload=root.querySelector('#cyc-upload-note'),word=root.querySelector('.sp-topper-wording');
if(!choices||!upload||!word)return;
function place(){
var checked=choices.querySelector('input[name="cyc-artwork"]:checked');if(!checked)return;
var label=checked.closest('label'),v=checked.value;
if(v==='finished'){moveAfter(upload,label);}
else if(v==='text'){moveAfter(word,label);}
else{moveAfter(upload,label);moveAfter(word,upload);}
upload.hidden=v==='text';word.hidden=v==='finished';
styleBlock(upload);styleBlock(word);
}
choices.addEventListener('change',function(){setTimeout(place,0);});place();
}
function init(){setupCorporate();setupCustom();}
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);else init();
})();